"use client";
import { Controller, FieldValues } from "react-hook-form";
import { FormInputControllerProps } from "./Common/FormInputControllerProps";
import {
  InputProps,
  SxProps,
  TextField,
  TextFieldProps,
  TextFieldVariants,
  Theme,
} from "@mui/material";
import { getFormError } from "./Common/utils";

interface TextFieldInputProps<T extends FieldValues>
  extends FormInputControllerProps<T> {
  label?: string;
  TextFieldProps?: Omit<
    TextFieldProps,
    "onChange" | "label" | "value" | "error" | "helperText"
  >;
  InputProps?: InputProps;
  disabled?: boolean;
  variant?: TextFieldVariants;
  sx?: SxProps<Theme>;
  multiline?: boolean;
  rows?: number | string;
  onChange?: (e: any) => void;
}

export function TextFieldInput<T extends FieldValues>(
  props: TextFieldInputProps<T>,
) {
  return (
    <Controller
      {...props.ControllerProps}
      name={props.propertyName}
      control={props.control}
      render={({ field, fieldState, formState: { errors } }) => {
        const formError = getFormError(props.propertyName, errors);

        return (
          <TextField
            multiline={props.multiline}
            rows={props.rows}
            name={props.propertyName}
            sx={props.sx}
            variant={props.variant ?? "outlined"}
            disabled={props.disabled}
            {...props.TextFieldProps}
            value={field.value ?? ""}
            label={props.label}
            onChange={(e) => {
              if (props.onChange) {
                props.onChange(e);
              }
              field.onChange(e);
            }}
            error={!!formError}
            helperText={formError}
            InputProps={{
              ...props.InputProps,
            }}
          />
        );
      }}
    />
  );
}
